module.exports = __webpack_public_path__ + "img/cg.99d333a8.webp";